import { Text, Flex } from "@fluentui/react-northstar";

import { PageHeaderStylesProps } from "./pageHeader.types";

export const PageHeader: React.FC<PageHeaderStylesProps> = ({
  headerStyles,
  headerContent,
  descriptionStyles,
  descriptionContent,
}) => {
  return (
    <Flex
      column
      vAlign="center"
      hAlign="center"
      gap="gap.small"
      padding="padding.medium"
    >
      <Text
        styles={headerStyles}
        as="h1"
        size="larger"
        weight="bold"
        align="center"
        content={<>{headerContent}</>}
      />
      {descriptionContent && (
        <Text
          styles={descriptionStyles}
          size="large"
          weight="regular"
          align="center"
          content={<>{descriptionContent}</>}
        />
      )}
    </Flex>
  );
};
